import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IDownloadFileProps } from '../../../components/DownloadFile';

export const generate = (
  props?: Partial<IComponentSchema<IDownloadFileProps>>
): IComponentSchema<IDownloadFileProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Download File',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.DownloadFile,
    'x-component-props': {
      fileId: undefined,
      filePath: undefined,
      modelInstanceId: undefined,
      label: 'Download',
      type: 'primary',
      variant: 'solid',
      size: 'middle',
      visible: true,
    },
    'x-component-props-config': {},
  };
};
